import React, { useContext }  from 'react';
import { NavLink } from 'react-router-dom';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import { makeStyles } from '@material-ui/core/styles';
import logo from 'src/data/logo';
import { navLinks } from './__data';

import UserContext from '../../context/UserContext';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles((theme) => ({
  navDisplayFlex: {
    display: 'flex',
    flexGrow: 1
  },
  linkText: {
    textDecoration: 'none',
    textTransform: 'uppercase',
    color: 'white'
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
  },
  sectionMobile: {
    display: 'block',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  }
}));

const AppBarDesktop = () => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const { userData, setUserData } = useContext(UserContext);
  const logout = () => {
    setUserData({
      token: undefined,
      user: undefined
    });
    localStorage.setItem('auth-token', '');
    enqueueSnackbar('A bientôt =)', { variant: 'success' });
  }

  return (
    <>
      <Toolbar disableGutters>
        <NavLink
          style={{padding: 0, margin: 0}}
          to={'/home'}
        >
          <img
            alt={logo.alt}
            src={logo.img}
            style={{marginRight: '2rem'}}
            title={logo.title}
          />
        </NavLink>
        <List
          aria-labelledby="main navigation"
          className={classes.navDisplayFlex}
          component="nav"
        >
          {navLinks.map(({ title, path }) => (
            <NavLink
              activeStyle={{
                fontWeight: 'bold',
                color: 'rgb(112, 195, 89)',
              }}
              className="MuiListItem-button"
              key={title}
              style={{color: 'black'}}
              to={path}
            >
              <Button style={{color: 'inherit', fontWeight: 'inherit'}}>
                {title}
              </Button>
            </NavLink>
                          
          ))}
        </List>
        {
          userData.token ?
            <NavLink to="/my-account">
              <Button
                color="secondary"
                variant="contained"
              >
                Mon Compte
              </Button>
            </NavLink>
            :
            <NavLink to="/login">
              <Button
                color="secondary"
                variant="contained"
              >
                Connexion
              </Button>
            </NavLink>
        }
      </Toolbar>
    </>
  );
}

export default AppBarDesktop;
